import clsx from "clsx";
import type { FunctionComponent, ReactNode } from "react";

type Props = {
	colorClassName?: string;
	highlightColorClassName?: string;
	isHighlighted?: boolean
	isDimmed?: boolean;
	label: string;
	subValue?: ReactNode;
	value: ReactNode;
};

const HorizontalStatDetail: FunctionComponent<Props> = ({
	colorClassName = "text-gray-700",
	highlightColorClassName = "text-red-600",
	isHighlighted = false,
	isDimmed = false,
	label,
	subValue,
	value,
}) => {

	return <div className="relative flex grow flex-col items-center justify-center px-2">
		<div className="text-xs font-medium text-gray-500">
			{label}
		</div>
		<div className={clsx("text-lg font-bold", isHighlighted ? highlightColorClassName : colorClassName, isDimmed && "opacity-50")}>
			{value}
		</div>
		{/* Positioned below the value, so it takes no space and the stats of a row stay aligned. */}
		{subValue && <div className="absolute inset-x-0 top-full whitespace-nowrap text-center text-xs text-gray-500">
			{subValue}
		</div>}
	</div>;
};

export default HorizontalStatDetail;